import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  CourseEditRootCourse: 'Course',
  GeneralName: 'Course name',
  GeneralDescription: 'Course description',
  GeneralSaveButton: 'Save',
  GeneralCancelButton: 'Cancel',
  PosterHeading: 'Course poster',
  DescriptionPlaceholder: 'What will learners be able to do after this course?',
  changesSaved: 'Changes saved',
  courseEdited:
    'Your changes have been saved as a draft. To make these updates visible to learners, please republish the course.',
  imagePlaceholder: 'Select image',
  republishTooltip: 'Republish the course to make changes go live.',
  courseNotPublished: 'This course is not published',
  publishCourse: 'Publish course',
  subjectSelectTitle: 'Course category',
  subjectSelectPlaceholder: 'Select a category for this course',
  categoryHint: 'Helps learners find this course.',
  posterReplace: 'Replace',
  posterRemove: 'Remove',
  posterEmptyTitle: 'Click to select an image',
  posterEmptyHint: 'JPG or PNG, 16:9 works best',
  posterShownHint: 'Shown on the course card.',
  posterOptionalHint: 'Optional, but courses with a poster get opened more.',
  completeRequiredHint: 'Complete the required fields to save.',
  allChangesSaved: 'All changes saved.',
};

const welsh = {
  CourseEditRootCourse: 'Cwrs',
  GeneralName: "Enw'r cwrs",
  GeneralDescription: "Disgrifiad o'r cwrs",
  GeneralSaveButton: 'Cadw',
  GeneralCancelButton: 'Canslo',
  PosterHeading: 'Poster y cwrs',
  DescriptionPlaceholder:
    'Beth fydd dysgwyr yn gallu ei wneud ar ôl y cwrs hwn?',
  changesSaved: "Newidiadau Wedi'u cadw",
  imagePlaceholder: 'Dewis delwedd',
  republishTooltip: "Ailgyhoeddi'r cwrs i wneud i'r newidiadau fynd yn fyw",
  courseNotPublished: "Nid yw'r cwrs wedi'i gyhoeddi",
  publishCourse: "Cyhoeddi'r cwrs",
  subjectSelectTitle: "Categori'r cwrs",
  subjectSelectPlaceholder: 'Dewiswch gategori ar gyfer y cwrs hwn',
  categoryHint: "Yn helpu dysgwyr i ddod o hyd i'r cwrs hwn.",
  posterReplace: 'Amnewid',
  posterRemove: 'Tynnu',
  posterEmptyTitle: 'Cliciwch i ddewis delwedd',
  posterEmptyHint: "JPG neu PNG, 16:9 sy'n gweithio orau",
  posterShownHint: 'Yn cael ei ddangos ar gerdyn y cwrs.',
  posterOptionalHint:
    'Dewisol, ond mae cyrsiau â phoster yn cael eu hagor yn amlach.',
  completeRequiredHint: 'Cwblhewch y meysydd gofynnol i gadw.',
  allChangesSaved: "Mae'r holl newidiadau wedi'u cadw.",
};

export const courseEditText: any = getLocalizationBasedOnLang(english, welsh);
